export const settings = {
  title: "設定",
  notification: {
    title: "通知",
    inApp: "アプリ内通知",
    message: "メッセージ通知",
    updated: "通知設定を更新しました",
    error: "設定の更新に失敗しました",
    pushEnabled:
      "Push通知が有効なため、この画面での切り替えは表示していません。",
  },
  withdraw: {
    label: "退会",
    confirm: "退会しますか？",
    description:
      "退会するとログインができなくなり、プロフィールは他のユーザーから見えなくなります。再度ログインする場合は復帰の処理が必要です。",
    execute: "退会する",
  },
} as const;
